import React, { Component, Fragment } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import * as myConstList from "../../../BaseUrl";
const baseUrl = myConstList.baseUrl;

class Leaderboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leaderboard: [],
      contestCreateType: "",
      predictionOrder: [],
      winning_distribution_type: "",
    };

    //this.getData = this.getData.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.leaderboard) {
      this.setState({
        leaderboard: nextProps.leaderboard,
      });
    }
    if (nextProps.contestCreateType) {
      this.setState({
        contestCreateType: nextProps.contestCreateType,
      });
      // console.log("contestCreateType===",nextProps.contestCreateType);
    }

    if (nextProps.predictionOrder) {
      this.setState({
        predictionOrder: nextProps.predictionOrder,
      });
    }
    if (nextProps.winning_distribution_type) {
      this.setState({
        winning_distribution_type: nextProps.winning_distribution_type,
      });
    }

    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }

    // let showChatHtml = () => {
    //     const html = [];
    //     var rank = 0;
    //   var profitArr=[];
    //     if(this.state.leaderboard.length != 0){
    //         this.state.leaderboard.map(function (value, i) {
    //             const mobileTemp = value.mobile;
    //             let mobileMasking = "";
    //             if(mobileTemp !==null){
    //                 mobileMasking = mobileTemp.replace(/\d(?=\d{4})/g, "*");
    //             }
    //             if(value.order_count>=1) {
    //                 var portfolioVal = value.portfoliovalue;
    //                 // if(profitArr.includes(portfolioVal)===false){
    //                     rank++;
    //                 // }
    //                 // profitArr.push(portfolioVal);
    //                 html.push(
    //                         <tr>
    //                             <td><span className="pr-2">{rank}</span></td>
    //                             <td><span className="pr-2">{value.name}</span></td>
    //                             <td><span className="pr-2">{mobileMasking}</span></td>
    //                             <td><span className="pr-2">{value.portfoliovalue}</span></td>
    //                             <td><span className="pr-2">{(value.per.toFixed(3))+"%"}</span></td>
    //                             <td><span className="pr-2">{value.winner_amount}</span>
    //                             <span className="pr-2">{value.winner_prize}</span></td>
    //                         </tr>
    //                 );
    //                 //console.log("profitArr.includes(portfolioVal)",profitArr.includes(portfolioVal));
    //             }
    //         })
    //     }
    //     return html;
    // }
    //this.getData();
  }

  showChatHtml = () => {
    // console.log("this.state.leaderboard", this.state.leaderboard);
    const html = [];
    var rank = 0;
    var profitArr = [];
    var collectThis = this;
    var arrData = this.state.leaderboard;
    console.log(this.state.contestCreateType, "contestCreateType", arrData);
    if (
      collectThis.state.contestCreateType === "coin" ||
      collectThis.state.contestCreateType === "price"
    ) {
      arrData = collectThis.state.predictionOrder;
    }

    function redactEmail(email) {
      const atIndex = email.indexOf("@");
      if (atIndex !== -1) {
        const domainIndex = email.indexOf(".", atIndex);
        const domain = email.slice(domainIndex);
        const username = email.slice(0, Math.min(3, atIndex));
        const redactedUsername = "*".repeat(atIndex - 3);
        return `${username}${redactedUsername}@${domain}`;
      } else {
        return email;
      }
    }

    if (arrData != undefined && arrData.length > 0) {
      arrData.map(function (value, i) {
        let dateValue = value.predictionCreatedDate;
        if (
          value.predictionUpdatedDate != null &&
          typeof value.predictionUpdatedDate != "undefined" &&
          value.predictionUpdatedDate != ""
        ) {
          dateValue = value.predictionUpdatedDate;
        }
        const mobileTemp = value.mobile;
        const mobileMasking = mobileTemp.replace(/\d(?=\d{4})/g, "*");
        if (value.order_count >= 1) {
          // var portfolioVal = value.portfoliovalue;
          // if (profitArr.includes(portfolioVal) === false) {
          rank++;
          // }
          // profitArr.push(portfolioVal);
          html.push(
            <tr>
              <td>
                <span className="pr-2">{rank}</span>
              </td>
              <td>
                <span className="pr-2">
                  {value.name != "null" ? value.name : ""}
                </span>
              </td>
              <td>
                <span className="pr-2">
                  {mobileMasking === ""
                    ? redactEmail(value.email)
                    : mobileMasking}
                </span>
              </td>
              {collectThis.state.contestCreateType !== "price" &&
                collectThis.state.contestCreateType !== "coin" &&
                collectThis.state.contestCreateType !== "forcasting" && (
                  <>
                    <td>
                      <span className="pr-2">
                        {value.portfoliovalue.toFixed(2)}
                      </span>
                    </td>
                    <td>
                      <span className="pr-2">{value.per.toFixed(3) + "%"}</span>
                    </td>
                  </>
                )}
              {collectThis.state.contestCreateType === "forcasting" && (
                <>
                  <td>
                    <span className="pr-2">{value.points}</span>
                  </td>
                  <td>
                    <span className="pr-2">{value.createdDate}</span>
                  </td>
                </>
              )}

              {collectThis.state.contestCreateType === "coin" && (
                <>
                  <td>
                    <span className="pr-2">{value.lastMarketPrice}</span>
                  </td>
                  <td>
                    <span className="pr-2">{value.predictionPrice}</span>
                  </td>
                  <td>
                    <span className="pr-2">
                      {moment
                        .utc(dateValue, "YYYY-MM-DD HH:mm:ss:SSS Z")
                        .utc()
                        .format("DD-MM-YY hh:mm:ss:SSS a")}
                    </span>
                  </td>
                </>
              )}

              {collectThis.state.contestCreateType === "price" && (
                <>
                  <td>
                    <span className="pr-2">{value.predictionPrice}</span>
                  </td>
                  <td>
                    <span className="pr-2">{value.lastMarketPrice}</span>
                  </td>
                  <td>
                    <span className="pr-2">{value.bidType}</span>
                  </td>
                  <td>
                    <span className="pr-2">
                      {moment
                        .utc(dateValue, "YYYY-MM-DD HH:mm:ss:SSS Z")
                        .utc()
                        .format("DD-MM-YY hh:mm:ss:SSS a")}
                    </span>
                  </td>
                </>
              )}

              {/* <td>
                <span className="pr-2">{value.order_count}</span>
              </td>
              <td>
                <span className="pr-2">
                  {value.per.toFixed(3) + "%" + " , " + value.order_count}
                </span>
              </td> */}
              <td>
                {collectThis.state.winning_distribution_type != "pool" && (
                  <span className="pr-2">{value.winner_amount}</span>
                )}
                <span className="pr-2">
                  {collectThis.state.winning_distribution_type == "pool" ||
                  collectThis.state.winning_distribution_type == "cash"
                    ? "₹ "
                    : ""}
                  {collectThis.state.winning_distribution_type == "pool"
                    ? Number(value.winner_prize).toFixed(2)
                    : value.winner_prize}
                </span>
              </td>
            </tr>
          );
          //console.log("profitArr.includes(portfolioVal)",profitArr.includes(portfolioVal));
        }
      });
    }
    return html;
  };
  // componentDidMount() {
  // this.getData();
  // }

  // getData() {
  //   axios
  //     .post(baseUrl + "api/user-data")
  //     .then((res) => {
  //       this.setState({ records: res.data.data });
  //     })
  //     .catch();
  // }

  // getData() {
  //   axios
  //     .post(baseUrl + "api/prediction-order",)
  //     .then((res) => {
  //       console.log("res.data.datares.data.data=",res.data.data);
  //       this.setState({ predictionOrder: res.data.data });
  //     })
  //     .catch();
  // }

  render() {
    return (
      <div className="">
        <div className="table-responsive winners_table">
          <table className="table  mb-0">
            <tr>
              <th className="th">Rank</th>
              <th className="th">User Name</th>
              <th className="th">Mobile No/Email ID</th>
              {this.state.contestCreateType !== "price" &&
                this.state.contestCreateType !== "coin" &&
                this.state.contestCreateType !== "forcasting" && (
                  <>
                    <th className="th">Portfolio Value</th>
                    <th className="th">Gain %</th>
                  </>
                )}
              {this.state.contestCreateType === "forcasting" && (
                <>
                  <th className="th">Points</th>
                  <th className="th">Time</th>
                </>
              )}
              {this.state.contestCreateType === "coin" && (
                <>
                  <th className="th">Coin Price</th>
                  <th className="th">Your Bid</th>
                  <th className="th">Date</th>
                </>
              )}
              {this.state.contestCreateType === "price" && (
                <>
                  <th className="th">Bid Price</th>
                  <th className="th">Closing Price</th>
                  <th className="th">Your Trend</th>
                  <th className="th">Date</th>
                </>
              )}

              {/* predictionOrder */}
              {/* <th className="th">No Of Transactions</th>
              <th className="th">Gain % & No Of Transactions</th> */}
              <th className="th">Winning Amount</th>
            </tr>
            <tbody>{this.showChatHtml()}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

Leaderboard.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  records: state.records,
});
export default connect(mapStateToProps)(Leaderboard);
